export enum SearchEntities {
  Declarant = 'declarant',
  Tenant = 'tenant',
  Welcoming = 'welcoming',
  Contractor = 'contractor',
  IndependentContractor = 'independent_contractor',
  InternalContractor = 'internal_contractor',
  Manager = 'manager',
  CareTaker = 'caretaker',
  Owner = 'owner',
  Salesperson = 'salesperson',
  Participant = 'participant',
  MaintenanceReferent = 'maintenance_referent',
  VehicleReferent = 'vehicle_referent',
  Referent = 'referent',
  ServiceBook = 'service_book'
}

export enum SearchSortTypes {
  MoreRecent = -1,
  Older = 1
}



// WEBPACK FOOTER //
// ./src/common/enums/search-entities.enum.ts